import { useContext, useState } from "react";
import api from "../../api";
import { useToast } from "../ToastContext";
import { LoadingContext } from "../LoadingContext";
import { AuthContext } from "../AuthContext";
import { set } from "lodash";

export interface ResponsavelType {
    id: number
    name: string;
    email?: string;
    cpf?: string;
    telephone?: string;
    position?: string;
    bank?: string;
    agency?: string;
    currentAccount?: string;
    observation?: string;
    pix?: string;
    empresaId: number;
    instituicaoId: number;
}

export interface CreateResponsavelType {
    name: string;
    email?: string;
    CPF?: string;
    telephone?: string;
    position?: string;
    bank?: string;
    agency?: string;
    currentAccount?: string;
    observation?: string;
    pix?: string;
    idEmpresa?: number;
    idInstituicao?: number;
}

export interface EditResponsavelType {
    id: number;
    name: string;
    email?: string;
    CPF?: string;
    telephone?: string;
    position?: string;
    bank?: string;
    agency?: string;
    currentAccount?: string;
    observation?: string;
    pix?: string;
    // empresaId: number;
    // instituicaoId: number;
}

export default function useResponsavel() {
    const showToast = useToast();
    const { setLoading } = useContext(LoadingContext);
    const { handleLogout, objUserTk } = useContext(AuthContext);
    const [listResponsavel, setListResponsavel] = useState<ResponsavelType[]>([]);
    const [responsavelPageCount, setResponsavelPageCount] = useState<number>(0);
    const [initialListResponsavel, setInitialListResponsavel] = useState<ResponsavelType[]>([]);
    const [responsavel, setResponsavel] = useState<ResponsavelType>({
        id: 0,
        name: "",
        email: "",
        cpf: "",
        telephone: "",
        position: "",
        bank: "",
        agency: "",
        currentAccount: "",
        observation: "",
        pix: "",
        empresaId: 0,
        instituicaoId: 0,
    });

    function createResponsavel(createResponsavelType: CreateResponsavelType): Promise<CreateResponsavelType | null> {
        setLoading(true);
        return api
            .post(`/Responsavel/create`, createResponsavelType)
            .then((response) => {
                const createdResponsavel: CreateResponsavelType = response.data;
                showToast("success", "Responsavel criado com sucesso.");
                setLoading(false);
                return createdResponsavel;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao criar responsavel. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao criar responsavel:", error);
                return null;
            });
    }

    function getResponsavelPaged(
        pageNumber: number,
        Name?: string,
        EmpresaId?: number,
        InstituicaoId?: number,
        pageSize?: number
    ): Promise<ResponsavelType[] | null> {
        setLoading(true);
        let url = `/Responsavel/getResponsavelPaged?pageNumber=${pageNumber}&pageSize=${pageSize}`;

        if (Name) {
            url += `&Name=${Name}`;
        }

        if (EmpresaId) {
            url += `&EmpresaId=${EmpresaId}`;
        }

        if (InstituicaoId) {
            url += `&InstituicaoId=${InstituicaoId}`;
        }

        return api
            .get(url)
            .then((response) => {
                setListResponsavel(response.data.result);
                setInitialListResponsavel(response.data.result);
                setResponsavelPageCount(response.data.pageCount);
                console.log(listResponsavel);
                setLoading(false);
                return response.data.result;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao carregar responsavel. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao carregar responsavel:", error);
                return null;
            });
    }

    function updateResponsavel(updateResponsavelData: EditResponsavelType): Promise<EditResponsavelType | null> {
        setLoading(true);
        return api
            .put(`/Responsavel/${updateResponsavelData.id}`, updateResponsavelData)
            .then((response) => {
                showToast("success", "Responsavel atualizada com sucesso.");
                setLoading(false);
                return response.data;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao atualizar responsavel. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao atualizar responsavel:", error);
                return null;
            });
    }

    function deleteResponsavel(responsavelId: number): Promise<ResponsavelType | null> {
        setLoading(true);
        return api
            .delete(`/Responsavel/delete/${responsavelId}`)
            .then(() => {
                setResponsavel({
                    id: 0,
                    name: "",
                    email: "",
                    cpf: "",
                    telephone: "",
                    position: "",
                    bank: "",
                    agency: "",
                    currentAccount: "",
                    observation: "",
                    pix: "",
                    empresaId: 0,
                    instituicaoId: 0,
                });
                showToast("success", "Responsavel deletada com sucesso.");
                setLoading(false);
                return null;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao deletar responsavel. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao deletar responsavel:", error);
                return null;
            });
    }

    function handleGetResponsavelById(responsavelId: number): Promise<ResponsavelType | null> {
        setLoading(true);
        return api
            .get(`/Responsavel/${responsavelId}`)
            .then((response) => {
                const responsavel: ResponsavelType = response.data;
                setResponsavel(responsavel);
                setLoading(false);
                return responsavel;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao buscar responsavel pelo ID. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao buscar responsavel pelo ID:", error);
                return null;
            });
    }

    function handleGetResponsavelByEmpresaId(empresaId: number): Promise<ResponsavelType[] | null> {
        setLoading(true);
        return api
            .get(`/Responsavel/getResponsavelByEmpresaId/${empresaId}`)
            .then((response) => {
                const responsavel: ResponsavelType[] = response.data;
                setListResponsavel(responsavel);
                setLoading(false);
                return responsavel;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao buscar responsaveis. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao buscar responsaveis pelo ID:", error);
                return null;
            });
    }

    function handleGetResponsavelByInstituicaoId(instituicaoId: number): Promise<ResponsavelType[] | null> {
        setLoading(true);
        return api
            .get(`/Responsavel/getResponsavelByInstituicaoId/${instituicaoId}`)
            .then((response) => {
                const responsavel: ResponsavelType[] = response.data;
                setListResponsavel(responsavel);
                setLoading(false);
                return responsavel;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao buscar responsaveis. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao buscar responsaveis pelo ID:", error);
                return null;
            });
    }

    return {
        createResponsavel,
        getResponsavelPaged,
        updateResponsavel,
        deleteResponsavel,
        handleGetResponsavelById,
        setListResponsavel,
        listResponsavel,
        setResponsavelPageCount,
        responsavelPageCount,
        setInitialListResponsavel,
        initialListResponsavel,
        setResponsavel,
        responsavel,
        handleGetResponsavelByEmpresaId,
        handleGetResponsavelByInstituicaoId
    };
}